var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "leaves_top" }),
      _vm._v(" "),
      _c("HeaderMenu_Site"),
      _vm._v(" "),
      _c("LateralMenu_Site"),
      _vm._v(" "),
      _c("div", { staticClass: "page-content", attrs: { id: "entreprises" } }, [
        _c("div", { staticClass: "logo" }),
        _vm._v(" "),
        _c("div", { staticClass: "habillage-header" }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "content-separateur" }, [
          _vm._v("Options supplémentaires"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content", attrs: { id: "ent-options" } }, [
          _c("div", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "observe-visibility",
                    rawName: "v-observe-visibility",
                    value: {
                      callback: _vm.ovCallbackOptions,
                      intersection: _vm.ovOptions,
                      once: true,
                    },
                    expression:
                      "{ callback: ovCallbackOptions, intersection: ovOptions, once: true }",
                  },
                ],
              },
              [
                _c("span", [_vm._v("Petit déjeuner + Escape Game")]),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _vm._m(2),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "observe-visibility",
                    rawName: "v-observe-visibility",
                    value: {
                      callback: _vm.ovCallbackOptions,
                      intersection: _vm.ovOptions,
                      once: true,
                    },
                    expression:
                      "{ callback: ovCallbackOptions, intersection: ovOptions, once: true }",
                  },
                ],
              },
              [
                _c("span", [_vm._v("Soirée privée + Escape Game")]),
                _vm._v(" "),
                _vm._m(3),
                _vm._v(" "),
                _vm._m(4),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "observe-visibility",
                    rawName: "v-observe-visibility",
                    value: {
                      callback: _vm.ovCallbackOptions,
                      intersection: _vm.ovOptions,
                      once: true,
                    },
                    expression:
                      "{ callback: ovCallbackOptions, intersection: ovOptions, once: true }",
                  },
                ],
              },
              [
                _c("span", [_vm._v("Escape Game mobiles")]),
                _vm._v(" "),
                _vm._m(5),
                _vm._v(" "),
                _vm._m(6),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content-separateur" }, [
          _vm._v("Et aussi..."),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content", attrs: { id: "jeux-de-piste" } }, [
          _c("div", { staticClass: "column left" }, [
            _c("div", [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "observe-visibility",
                      rawName: "v-observe-visibility",
                      value: {
                        callback: _vm.ovCallbackPadquest,
                        intersection: _vm.ovOptions,
                        once: true,
                      },
                      expression:
                        "{ callback: ovCallbackPadquest, intersection: ovOptions, once: true }",
                    },
                  ],
                },
                [
                  _c("div", { staticClass: "icon host" }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "Accompagné par un animateur tout au long du parcours"
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "observe-visibility",
                      rawName: "v-observe-visibility",
                      value: {
                        callback: _vm.ovCallbackPadquest,
                        intersection: _vm.ovOptions,
                        once: true,
                      },
                      expression:
                        "{ callback: ovCallbackPadquest, intersection: ovOptions, once: true }",
                    },
                  ],
                },
                [
                  _c("div", { staticClass: "icon gps" }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("Enigmes et défis GPS autour du patrimoine"),
                  ]),
                ]
              ),
            ]),
          ]),
          _c("div", { staticClass: "column right" }, [
            _c("div", [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "observe-visibility",
                      rawName: "v-observe-visibility",
                      value: {
                        callback: _vm.ovCallbackPadquest,
                        intersection: _vm.ovOptions,
                        once: true,
                      },
                      expression:
                        "{ callback: ovCallbackPadquest, intersection: ovOptions, once: true }",
                    },
                  ],
                },
                [
                  _vm._v(
                    "\n                        Nos jeux de piste\n                        "
                  ),
                  _c("br"),
                  _vm._v("en plein air\n                    "),
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "observe-visibility",
                      rawName: "v-observe-visibility",
                      value: {
                        callback: _vm.ovCallbackPadquest,
                        intersection: _vm.ovOptions,
                        once: true,
                      },
                      expression:
                        "{ callback: ovCallbackPadquest, intersection: ovOptions, once: true }",
                    },
                  ],
                },
                [
                  _c("span", [
                    _vm._v("L'aventure continue, grandeur nature !"),
                  ]),
                  _vm._v(
                    "\n                        Affrontez-vous en plein air de 2 à 6 équipes en\n                        "
                  ),
                  _c("br"),
                  _vm._v(
                    "simultané avec le système de tablettes\n                        "
                  ),
                  _c("br"),
                  _vm._v("interactives "),
                  _vm._m(7),
                  _vm._v(
                    " (jusqu'à 36 personnes).\n\n                        "
                  ),
                  _c("p", [_vm._v(" ")]),
                  _vm._v(
                    '\n\n                        Découvrez également nos défis "safari photo"\n                        '
                  ),
                  _c("br"),
                  _vm._v(
                    "pour de grands groupes jusqu'à 120\n                        "
                  ),
                  _c("br"),
                  _vm._v("personnes.\n                    "),
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: { href: "https://www.padquest.fr", target: "_blank" },
                },
                [_vm._v("Site dédié")]
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm._m(8),
      _vm._v(" "),
      _c("Footer", {
        attrs: {
          seo_contentH1:
            "Nos offres entreprise d’escape game pour du team building ou séminaire indoor ou extérieur",
          seo_contentH2:
            "Nos offres : petit déjeuner, soirée privée, activité de cohésion d’équipe, activité de loisir directement de l’entreprise,<br/>escape game et jeux de piste en plein air et à l’extérieur",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content", attrs: { id: "ent-header" } }, [
      _c("div", [
        _c("div", { staticClass: "bandeau" }, [
          _c("span", [_vm._v("- Offres Entreprises -")]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "bandeau-wordings" }, [
              _vm._v(
                "\n                            Partage, cohésion, communication et convivialité...\n                        "
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", [
          _c("span", [_vm._v("Une activité idéale de Team Building")]),
          _vm._v(" "),
          _c("h3", [
            _vm._v(
              "\n                        L’Escape Game en entreprise est l’activité idéale de team buiding, pour souder ses équipes et favoriser la communication.\n                    "
            ),
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("h3", [
            _vm._v(
              "\n                        Chaque membre devra apprendre à écouter et à participer. Les maîtres-mots sont : coopération, écoute, communication. \n                        Renforcez le sentiment d’accomplissement d’un objectif à plusieurs.\n                    "
            ),
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("h3", [
            _vm._v(
              "\n                        L’Escape Game pour les professionnels a l’avantage de séduire un grand nombre de personnalités différentes, \n                        hommes ou femmes, et il n’y a pas d’âge pour l’apprécier.\n                    "
            ),
          ]),
          _vm._v(" "),
          _c("a", { attrs: { href: "/contact" } }, [_vm._v("Devis")]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _vm._v(
        '\n                        Savourez un petit-déjeuner "réveille-méninges" dans notre salon\n                        '
      ),
      _c("br"),
      _vm._v(
        "privatisé toute la matinée et profitez de nos Escape Game.\n                        "
      ),
      _c("br"),
      _vm._v(
        "Une façon conviviale de commencer la journée.\n                    "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", [_vm._v("- Salon privatisé toute la matinée jusqu'à 11h.")]),
      _vm._v(" "),
      _c("li", [
        _vm._v("- Buffet de viennoiseries, café, thé et jus de fruits."),
      ]),
      _vm._v(" "),
      _c("li", [_vm._v("- Jusqu'à 20 personnes.")]),
      _vm._v(" "),
      _c("li", [_vm._v("- Profitez de nos Escape Game.")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _vm._v(
        "\n                        Privatisez notre salon pour une soirée. Profitez de nos Escape\n                        "
      ),
      _c("br"),
      _vm._v(
        "Game sans stress, pour votre événementiel, avec possibilité de\n                        "
      ),
      _c("br"),
      _vm._v("cocktail dinatoire.\n                    "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", [_vm._v("- Salon privatisé toute la soirée jusqu'à 23h30.")]),
      _vm._v(" "),
      _c("li", [_vm._v("- Apéritif dinatoire traiteur.")]),
      _vm._v(" "),
      _c("li", [_vm._v("- Jusqu'à 40 personnes.")]),
      _vm._v(" "),
      _c("li", [_vm._v("- Accès à nos Escape Game.")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _vm._v(
        "\n                        Quand l'Escape Game se déplace à domicile. Dans vos\n                        "
      ),
      _c("br"),
      _vm._v(
        "locaux ou en extérieur sous barnum, découvrez nos\n                        "
      ),
      _c("br"),
      _vm._v(
        "scénarios spécialement adaptés à vos événementiels.\n                    "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", [_vm._v("- Scénarios de 30 à 60 minutes.")]),
      _vm._v(" "),
      _c("li", [_vm._v("- Jusqu'à 100 joueurs sur la journée.")]),
      _vm._v(" "),
      _c("li", [_vm._v("- Installation dans le lieu de votre choix.")]),
      _vm._v(" "),
      _c("li", [_vm._v("- Déplacement dans toute la France.")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [_c("i", [_vm._v("pad")]), _vm._v("Quest®")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { attrs: { id: "leaves_sides" } }, [
      _c("div", { staticClass: "left" }),
      _vm._v(" "),
      _c("div", { staticClass: "right" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }